module.exports = __webpack_public_path__ + "static/media/img.fc1d5442.png";